export enum GuideType{
    MEMBERS = "MEMBERS",
    GROUP_MEMBERS = "GROUP_MEMBERS"
}

export enum MemberItemType {
    SIGNUP = "SIGNUP",
    MYPAGE = "MYPAGE",
    VOUCHER_PURCHASE = "VOUCHER_PURCHASE",
    DOWNLOAD = "DOWNLOAD",
    LOGIN = "LOGIN",
    GAME = "GAME",
    RESULT = "RESULT",
}

export enum GroupMemberItemType {
    CODE = "CODE",
    DOWNLOAD = "DOWNLOAD",
    LOGIN = "LOGIN",
    PROCESSING = "PROCESSING",
    RESULT = "RESULT",
}